export default "__VITE_ASSET__C3Ylv2r5__"